// extracted by mini-css-extract-plugin
module.exports = {"root":"_1e6c43","title":"_0896c9","lastUpdate":"_17b0b6","contributors":"_cf1bf7","avatars":"_ccccf4","legalText":"_de7dcd"};